import { useTranslation } from "react-i18next";
import * as yup from "yup";

const useDownloadReleaseClientXmlFileSchema = () => {
    const { t } = useTranslation();

    return yup.object({
        client: yup.string().required(t("messages.inputMsgs.required")),
        fileType: yup.string().required(t("messages.inputMsgs.required")),
        territory: yup.string().required(t("messages.inputMsgs.required")),
        xmlType: yup.string().required(t("messages.inputMsgs.required")),
    });
};

export default useDownloadReleaseClientXmlFileSchema;
